"use client";

import Image from "next/image";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { getLocaleFromPathname, withLocale } from "@/lib/i18n";
import { getSiteContent } from "@/lib/site-content";

export function Hero() {
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const content = getSiteContent(locale).landing;

  return (
    <section className="container mx-auto min-h-screen px-4 md:px-6 py-12 md:py-24 flex flex-col md:flex-row items-center justify-between gap-12">
      <div className="w-full md:w-[45%] space-y-8 flex-shrink-0">
        <h1 className="text-4xl md:text-6xl font-medium leading-tight">
          {content.heroTitle}
        </h1>
        <p className="text-xl text-gray-600 max-w-md">
          {content.heroDescription}
        </p>
        <Button asChild className="h-14 px-8 text-lg rounded-[14px] bg-positivus-dark text-white hover:bg-positivus-dark/90">
          <Link href={withLocale(locale, "/#tools")}>{content.heroCta}</Link>
        </Button>
      </div>
      
     <div className="w-full md:w-[100%] hidden md:flex relative md:left-16 justify-center md:justify-end">
        <div className="relative w-full">
           <Image 
             src="/images/hero2.webp" 
             alt={content.heroTitle}
             width={1200}
             height={800} 
             className="w-full h-auto object-contain"
             priority
             sizes="(max-width: 768px) 100vw, 55vw"
           />
        </div>
      </div>
    </section>
  );
}
